import { TranslocoService } from '@jsverse/transloco';
import { combineLatest, map, Observable } from 'rxjs';

import {
	DeviceUiSettingsFactoryResetBehaviorPlugin,
	FactoryResetText
} from '@shure/device-ui/settings/factory-reset/data-access';
import { DeviceUiSettingsGeneralBehaviorPlugin } from '@shure/device-ui/settings/general/data-access';
import { DeviceUiPage, DeviceUiRoute } from '@shure/device-ui/shared/services';
import { DeviceUiShellDeviceBehaviorPlugin } from '@shure/device-ui/shell/data-access';
import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceBehaviorPlugin, DeviceNameBehaviorPlugin } from '@shure/shared/angular/device-behavior/core';
import { shUseTranslation } from '@shure/shared/angular/utils/i18n';
import { ThemeService } from '@shure/shared/angular/utils/theming';

@shUseTranslation('scDevUiSharedDevBehavior', (lang) => import(`../i18n/${lang}`))
export class MxwNdxDeviceUiDeviceBehaviorPlugin
	implements
		DeviceBehaviorPlugin,
		DeviceUiShellDeviceBehaviorPlugin,
		DeviceUiSettingsGeneralBehaviorPlugin,
		DeviceUiSettingsFactoryResetBehaviorPlugin,
		DeviceNameBehaviorPlugin
{
	public readonly models: DeviceModel[] = [
		DeviceModel.MXWNDX2,
		DeviceModel.MXWNDX4,
		DeviceModel.MXWNDX4G,
		DeviceModel.MXWNDX8,
		DeviceModel.MXWNDX8G
	];

	constructor(
		protected readonly transloco: TranslocoService,
		protected readonly themeService: ThemeService
	) {}

	public getAvailablePages$(
		_model: DeviceModel,
		_options?: { virtual?: boolean | undefined; autoCoverageMode?: boolean | undefined } | undefined
	): Observable<DeviceUiPage[] | undefined> {
		return combineLatest([
			this.transloco.selectTranslate('scDevUiSharedDevBehavior.toolbar.labels.charger-bays'),
			this.transloco.selectTranslate('scDevUiSharedDevBehavior.toolbar.labels.settings')
		]).pipe(
			map(([chargerBaysLabel, settingsLabel]) => [
				{
					route: DeviceUiRoute.ChargerBays,
					label: chargerBaysLabel
				},
				{
					route: DeviceUiRoute.Settings,
					label: settingsLabel
				}
			])
		);
	}
	public getDefaultRoute(_model: DeviceModel): DeviceUiRoute | undefined {
		return DeviceUiRoute.ChargerBays;
	}

	public showPatentInfo(): boolean {
		return true;
	}

	public getResetText(_model: DeviceModel): FactoryResetText {
		return {
			tab$: this.transloco.selectTranslate('scDevUiSharedDevBehavior.settings.factory-reset'),
			title: this.transloco.translate('scDevUiSharedDevBehavior.settings.factory-reset'),
			button: this.transloco.translate(
				'scDevUiSharedDevBehavior.settings.factory-reset-page.restore-factory-defaults'
			)
		};
	}

	public getDeviceNameMaxLength(_model: DeviceModel): number | undefined {
		return 31;
	}

	public isSwitchedModeWithoutAudioNetworkDevice(model: DeviceModel): boolean {
		if (this.models.includes(model) && model !== DeviceModel.MXWNDX2) {
			return true;
		}
		return false;
	}
}
